import { enforce, create, test, only } from 'vest';

export default create((currentField, data = {}) => {
    only(currentField);

    test('current_password', 'Valor requerido', () => {
        enforce(data.current_password).isNotEmpty();
    });

    test('password', 'Valor requerido', () => {
        enforce(data.password).isNotEmpty();
    });

    test('password', 'Mínimo 8 caracteres', () => {
        enforce(data.password).longerThanOrEquals(8);
    });

    test('password_confirmation', 'Valor requerido', () => {
        enforce(data.password_confirmation).isNotEmpty();
    });

    test('password_confirmation', 'Las contraseñas no coinciden', () => {
        enforce(data.password_confirmation).equals(data.password);
    });
});
